import { render } from "./addCompany.vue?vue&type=template&id=5103404b"
import script from "./addCompany.vue?vue&type=script&lang=js"
export * from "./addCompany.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pro-cms-dtinsights/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__